module.exports = __webpack_public_path__ + "static/media/7.472de1f9.jpg";